import React, { useContext, useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import api from '../../services/api';
import { AuthContext } from '../../context/Auth/AuthContext';
import { Grid, Select, MenuItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Facebook, WhatsApp } from '@material-ui/icons';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Instagram } from '@mui/icons-material';
import { i18n } from '../../translate/i18n';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';

const useStyles = makeStyles((theme) => ({
  online: {
    fontSize: 11,
    color: '#25d366',
  },
  offline: {
    fontSize: 11,
    color: '#e1306c',
  },
  paper: {
    borderRadius: 16,
    overflow: 'hidden',
    minWidth: 600,
    maxWidth: 600,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4, 3, 2.5),
    background: 'linear-gradient(135deg, #f0f4ff 0%, #e8f5e9 100%)',
    borderBottom: '1px solid #e0e0e0',
  },
  iconCircle: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 12px rgba(25,118,210,0.18)',
    marginBottom: theme.spacing(1.5),
    '& svg': {
      fontSize: 30,
      color: '#1976d2',
    },
  },
  headerTitle: {
    fontWeight: 700,
    fontSize: '1.1rem',
    color: '#1a1a1a',
    textAlign: 'center',
  },
  content: {
    padding: theme.spacing(3, 4),
  },
  actions: {
    padding: theme.spacing(1.5, 3, 2.5),
    borderTop: '1px solid #f0f0f0',
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
  },
  btnCancel: {
    borderRadius: 10,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1, 3),
    backgroundColor: '#db6565',
    color: '#fff',
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#c62828', boxShadow: 'none' },
  },
  btnConfirm: {
    borderRadius: 10,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1, 3),
    backgroundColor: '#2e7d32',
    color: '#fff',
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#1b5e20', boxShadow: 'none' },
  },
}));

const ConfirmationModal = ({
  title,
  children,
  open,
  onClose,
  onConfirm,
  isCellPhone,
  onSave,
  confirmLabel,
}) => {
  const classes = useStyles();
  const [selectedWhatsapp, setSelectedWhatsapp] = useState('');
  const [whatsapps, setWhatsapps] = useState([]);
  const { user } = useContext(AuthContext);
  const { companyId } = user;

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        api
          .get(`/whatsapp`, { params: { companyId, session: 0 } })
          .then(({ data }) => setWhatsapps(data));
      };

      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [open]);

  const IconChannel = (channel) => {
    switch (channel) {
      case 'facebook':
        return <Facebook style={{ color: '#3b5998', verticalAlign: 'middle' }} />;
      case 'instagram':
        return <Instagram style={{ color: '#e1306c', verticalAlign: 'middle' }} />;
      case 'whatsapp':
        return <WhatsApp style={{ color: '#25d366', verticalAlign: 'middle' }} />;
      default:
        return 'error';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="confirm-dialog"
      PaperProps={{ className: classes.paper }}
    >
      <Box className={classes.header}>
        <Box className={classes.iconCircle}>
          <HelpOutlineIcon />
        </Box>
        <Typography id="confirm-dialog" className={classes.headerTitle}>
          {title}
        </Typography>
      </Box>

      <DialogContent className={classes.content}>
        <Typography align="center">{children}</Typography>
        {isCellPhone && (
          <Grid style={{ width: 300, marginTop: 10 }} container>
            <Grid xs={12} item>
              <Select
                required
                fullWidth
                displayEmpty
                variant="outlined"
                value={selectedWhatsapp}
                onChange={(e) => {
                  setSelectedWhatsapp(e.target.value);
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  if (selectedWhatsapp === '') {
                    return 'Selecione uma Conexão';
                  }
                  const whatsapp = whatsapps.find((w) => w.id === selectedWhatsapp);
                  return whatsapp?.name;
                }}
              >
                {whatsapps?.length > 0 &&
                  whatsapps.map((whatsapp, key) => (
                    <MenuItem dense key={key} value={whatsapp.id}>
                      <ListItemText
                        primary={
                          <>
                            {IconChannel(whatsapp.channel)}
                            <Typography
                              component="span"
                              style={{
                                fontSize: 14,
                                marginLeft: '10px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                lineHeight: '2',
                              }}
                            >
                              {whatsapp.name} &nbsp;{' '}
                              <p
                                className={
                                  whatsapp.status === 'CONNECTED' ? classes.online : classes.offline
                                }
                              >
                                ({whatsapp.status})
                              </p>
                            </Typography>
                          </>
                        }
                      />
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions className={classes.actions} disableSpacing>
        <Button
          variant="contained"
          className={classes.btnCancel}
          startIcon={<CancelIcon />}
          onClick={() => onClose(false)}
        >
          {i18n.t('confirmationModal.buttons.cancel')}
        </Button>
        <Button
          variant="contained"
          className={classes.btnConfirm}
          startIcon={<CheckIcon />}
          onClick={() => {
            if (isCellPhone) {
              onSave(selectedWhatsapp);
            }
            onClose(false);
            onConfirm();
          }}
        >
          {confirmLabel ?? i18n.t('confirmationModal.buttons.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
